<template>
  <div class="mainChild-container">
    <section class="mainActions-container">
      <div
        class="mainAction-button-container"
        v-for="item in mainActions"
        :key="item.id"
        :ref="item.title === 'My Stars To Spend' ? 'starButton' : 'homeButton'"
      >
        <b-button
          class="mainAction-button"
          :class="{ 'mainAction-button-stars': item.title === 'My Stars To Spend' }"
          :style="`background-color:${item.color}`"
          :to="item.router"
        >
          <div class="button-background" style="mix-blend-mode: multiply">
            <div v-if="item.title === 'My Stars To Spend'" class="shadow-double">
              <div class="left-shadow" :style="`background-color: ${item.color}`"></div>
              <div class="right-shadow" :style="`background-color: ${item.color}`"></div>
            </div>
            <div v-else class="shadow-single" :style="`background-color: ${item.color}`"></div>
          </div>
          <div class="button-money left" v-if="`${item.title}` === 'My Stars To Spend'">
            <div class="button-money-container">
              <span>{{ todayStars }}</span>
              <img src="@/assets/icons/icon-money-star.png" />
            </div>
            <span class="label-stars">Daily Stars</span>
          </div>
          <img :src="item.icon" v-else />
          <span>{{ item.title }}</span>
          <div class="button-money" v-if="`${item.title}` === 'My Stars To Spend'">
            <div class="button-money-container">
              <span>{{ getUserScore }}</span>
              <img src="@/assets/icons/icon-money-star.png" />
            </div>
            <span class="label-stars">Big Stars</span>
          </div>
        </b-button>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
const mainActions = require('@/utils/optionsMainChild.js');

export default {
  components: {},
  data() {
    return {
      starsWidth: 0,
      todayStars: 0,
      mainActions,
    };
  },
  mounted() {
    this.loadStarsToday();
  },
  computed: {
    ...mapGetters('user', ['getUserName', 'getUserScore', 'getUserId']),
    ...mapGetters('rewards', ['getChildSelectedRewards']),
  },
  methods: {
    ...mapActions('rewards', ['FetchChildRewards']),
    async loadStarsToday() {
      try {
        await this.FetchChildRewards(this.getUserId);
        const selectedChildReward = this.getChildSelectedRewards(this.getUserId);
        this.todayStars = selectedChildReward.today_stars;
      } catch (error) {
        (error) => console.error(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  position: relative;
  padding: 0;
  margin: 0;
}

.mainActions-container {
  width: min(1366px, 90%);
  background-color: transparent;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
  align-items: center;
  margin: 50px auto;
  gap: 30px;
}
.mainAction-button-container {
  width: 20%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-width: 315px;
  .mainAction-button {
    display: flex;
    overflow: hidden;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 180px;
    min-width: 315px;
    border: none;
    border-radius: 15px;
    flex-grow: 1;
    & > img {
      height: 100px;
    }
    & > span {
      font-size: calc(1vw + 1.2rem);

      color: #2c2164;
      margin: 0;
    }
  }
}

.mainAction-button-container:nth-child(1) {
  width: 40%;
  flex-grow: 2;
}

.mainAction-button-container:nth-child(2) {
  width: 40%;
  flex-grow: 1;
  display: flex;
  flex-grow: 10;
  .mainAction-button {
    flex-direction: row;
    justify-content: space-around;
    & > img {
      margin: 0px 0px 0px 0;
    }
    & > span {
      font-size: calc(1vw + 1.2rem);
      margin: 0;
    }
  }
}

.mainAction-button-container:nth-child(even) {
  .mainAction-button > .button-background {
    transform: rotate(180deg);
  }
}

.mainAction-button-stars {
  flex-grow: 1;
  gap: 0.7rem;
  & > img {
    order: 1;
    width: 30%;
    min-height: 100px;
  }
  & > span {
    order: 2;
    flex-grow: 1;
    font-size: calc(1vw + 1.2rem);
    color: #2c2164;
    margin: 0;
    width: 35%;
  }
  .button-money {
    order: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 30%;
    color: #000;
    .button-money-container {
      display: flex;
      justify-content: center;
      align-items: center;
      & > img {
        width: 45px;
      }
      & > span {
        font-size: 50px;
        line-height: 50px;
        color: #2b2062;
        @media screen and (max-width: 480px) {
          font-size: 40px;
        }
      }
    }
    &.left {
      order: 1;
    }
  }

  @media (max-width: 535px) {
    flex-wrap: wrap;

    .shadow-double {
      transform: rotate(180deg);
      :nth-child(2) {
        display: none;
      }
    }

    & > span {
      order: 3;
      width: 100%;
    }

    .button-money {
      order: 2;
      flex-wrap: wrap;
      flex-direction: column-reverse;
      gap: 0;
    }
  }
}

.mainAction-button-stars-mobile {
  .shadow-double {
    transform: rotate(180deg);
    :nth-child(2) {
      display: none;
    }
  }

  flex-wrap: wrap;
  & > span {
    order: 3;
    width: 100%;
  }

  .button-money {
    order: 2;
    flex-wrap: wrap;
    flex-direction: column-reverse;
    gap: 0;
  }
}

.button-background {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  & > img {
    width: 100%;
  }
}

.shadow-single {
  position: absolute;
  margin: 0 auto;
  left: -5%;
  width: 110%;
  height: 65%;
  border-radius: 0px 0px 100% 100% / 0px 0px 60% 60%;
  opacity: 0.5;
}

.shadow-double {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: -10%;
  width: 100%;
  height: 120%;
  div {
    display: inline-block;
    max-width: 230px;
    width: 50%;
    height: 100%;
    border-radius: 0px 75% 75% 0px / 0px 100% 100% 0;
    opacity: 0.5;
  }
  :nth-child(2) {
    transform: rotate(180deg);
  }
}

.background-double-shadow {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > img {
    height: 100%;
  }
}
</style>
